import React from 'react'

import Plus from '../../../assets/plus.svg'
import Minus from '../../../assets/minus.svg'

import PropTypes from 'prop-types'

import './ItemQuantity.css'

export const ItemQuantity = ({ field, form, ...props }) => (
  <div data-testid='itemQuantity' styleName='wrapper'>
    <span styleName='label'>Quantity</span>
    <div styleName='spinner'>
      <button
        data-testid='decrement'
        styleName='button'
        disabled={field.value <= 1}
        type='button'
        onClick={() => {
          form.setFieldValue(field.name, field.value - 1)
        }}
      >
        <Minus />
      </button>
      <span data-testid='modifier-item-quantity' styleName='quantity'>{field.value}</span>
      <button
        data-testid='increment'
        styleName='button'
        type='button'
        onClick={() => {
          form.setFieldValue(field.name, field.value + 1)
        }}
      >
        <Plus />
      </button>
    </div>
    <div />
  </div>

)

const FormShape = PropTypes.shape({
  errors: PropTypes.object,
  touched: PropTypes.object,
  setFieldValue: PropTypes.func
})

const FieldShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  value: PropTypes.number,
  onChange: PropTypes.func,
  onBlur: PropTypes.func
})

ItemQuantity.propTypes = {
  field: FieldShape.isRequired,
  form: FormShape.isRequired
}
